export const DisplayLocation = {
  BACKGROUND: 0,
  FOREGROUND: 1,
};

export default {
  DisplayLocation,
};
